import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//services
import { EmployeeService } from 'src/app/pages/employee/services/employee.service';

@Component({
  selector: 'app-checklist-item-click-sign-modal',
  templateUrl: './checklist-item-click-sign-modal.component.html',
  styleUrls: ['./checklist-item-click-sign-modal.component.css']
})
export class ChecklistItemClickSignModalComponent implements OnInit {

  @Input() type: any;
  img: any;

  constructor(private employeeService: EmployeeService, private activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.getTypeSign(this.type);
  }

  getTypeSign(type: any){
    this.employeeService.getTypeSign(type).then((response: any)=> {
      this.img = "data:image/png;base64," + response;  
    });
  }
    
  cancelClicked() {
    this.activeModal.close();
  }

  confirmClicked() {
    this.activeModal.close(this.img);
  }
}
